export const environment = {
  apiUrl: 'http://localhost:5201/api'
};
